// Listes déroulantes des champs manuels de la navette de paie — à ajuster si besoin.
export const CONTRACT_NATURE_OPTIONS = ["CDI", "CDD", "Alternance", "Stage"];

export const EMPLOYEE_STATUS_OPTIONS = ["Cadre", "Cadre forfait jour", "ETAM"];
